import { login, logout } from '@/api/auth'

const state = {
  token: localStorage.getItem('jdcpt_token') || '',
  userInfo: JSON.parse(localStorage.getItem('jdcpt_user') || 'null')
}

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token
    localStorage.setItem('jdcpt_token', token)
  },
  SET_USER_INFO(state, info) {
    state.userInfo = info
    localStorage.setItem('jdcpt_user', JSON.stringify(info || null))
  },
  CLEAR(state) {
    state.token = ''
    state.userInfo = null
    localStorage.removeItem('jdcpt_token')
    localStorage.removeItem('jdcpt_user')
  }
}

const actions = {
  login({ commit }, form) {
    return login(form).then(res => {
      commit('SET_TOKEN', res.data.token)
      commit('SET_USER_INFO', res.data.userInfo)
      return res
    })
  },
  resetToken({ commit }) {
    commit('CLEAR')
  },
  logout({ commit }) {
    return logout().catch(() => {}).finally(() => {
      commit('CLEAR')
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
